import vars from '@/config/vars';

export default {
    namespaced: true,

    state: {
        HasLogo: false,
        BackgroundColor: null,
        IsCustomizationEnabled: false,
        Id: null
    },

    getters: {
        getLogoUrl(state) {
            const logoId = state.Id;
            return `${vars.CIELO_CHECKOUT_URL}/TransactionalVNext/Checkout/GetLogoMerchantByLayoutId/${logoId}`;
        },

        getNewLogoUrl(state) {
            const logoId = state.Id;
            return `${vars.CIELO_CHECKOUT_URL}/TransactionalVNext/Checkout/GetLogoMerchantByLayoutId/${logoId}`;
        },
    },

    mutations: {
        /**
         * Mapeia o response da api para o módulo
         */
        setFromRequest(state, data) {
            state.BackgroundColor = data.BackgroundColor;
            state.HasLogo = data.HasLogo;
            state.IsCustomizationEnabled = data.IsCustomizationEnabled;
            state.Id = data.Id;
        }
    }
};
